export const NATIVE_HEIGHT = 110;
export const NATIVE_WIDTH = 904;
export const ASPECT_RATIO = NATIVE_WIDTH / NATIVE_HEIGHT;